import React from 'react';
import BillStatusBadge from '../../../BillStatusBadge/BillStatusBadge';

type StatusBadgeProps = {
  status: string
};

export const StatusRenderer = ({ status }: StatusBadgeProps) => (<BillStatusBadge status={status} testId='BillsHub__table-column-status' />);
